/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import MaxLengthNumericEditor from '../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import CheckBoxRender from './checkBoxRender';

const numberAndTextComparator = (valueA, valueB) => {
  return valueA?.trim()?.localeCompare(valueB?.trim());
};

export const ProviderHead = [
  {
    headerName: 'Name',
    field: 'name',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'nameRenderName',
    cellClass: 'frr-ellipsis-text-overlap',
    sortingOrder: ['desc', 'asc'],
    comparator: numberAndTextComparator,
    filter: 'agTextColumnFilter',
    cellStyle: { borderRightColor: Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Provider ID Type',
    valueGetter: (params) => {
      const data = params.data || {};
      return (
        data.providerIdTypeShortDesc ||
        data.providerIdTypeDesc ||
        data?.providerPK?.providerIdTypeCd ||
        ''
      );
    },
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_100,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Provider ID',
    field: 'providerPK.providerId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_100,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
export const cellHead = [
  {
    headerName: 'Provider ID Type',
    valueGetter: (params) => {
      const data = params.data || {};
      return (
        data.providerIdTypeShortDesc ||
        data.providerIdTypeDesc ||
        data?.providerPK?.providerIdTypeCd ||
        ''
      );
    },
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_100,
    // maxWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Provider ID',
    field: 'providerPK.providerId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_100,
    // maxWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_20,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: 'Name',
    field: 'name',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_300,
    // maxwidth: Styles.Width_350,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_50,
    // resizable: false,
    cellRenderer: 'nameRenderName',
    cellClass: 'frr-ellipsis-text-overlap',
    filter: 'agTextColumnFilter',
    cellStyle: { borderRightColor: Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const clientGroupPlanHead = [
  {
    headerName: 'Client/Group/Plan',
    field: 'clientGroupPlan',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Plan Name',
    field: 'planName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    resizable: false,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const contractTableHead = [
  {
    headerName: 'Contract ID',
    field: 'contractNum',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_80,
    cellEditor: MaxLengthNumericEditor,
    sort: 'asc',
    maxLength: Styles.Length_30,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Contract Name',
    field: 'contractName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_80,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    resizable: false,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const groupTableHead = [
  {
    headerName: 'Group ID',
    field: 'groupId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: {
      'border-right-color': Styles.BorderColor,
      display: 'flex',
      alignItems: 'center',
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    sort: 'asc',
    sortingOrder: ['desc', 'asc'],
  },
  {
    headerName: 'Group Name',
    field: 'groupName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: {
      'border-right-color': Styles.BorderColor,
      display: 'flex',
      alignItems: 'center',
    },
    resizable: false,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const manuFactureChildHead = [
  {
    headerName: 'Type',
    field: 'keyTypeCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_80,
    sort: 'asc',
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Contact Name',
    field: 'contactName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_80,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Corp Name',
    field: 'corpName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_80,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    resizable: false,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const manuFactureHead = [
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sort: 'asc',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    resizable: false,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const superClientModalHead = [
  {
    headerName: 'Client ID',
    field: 'clientId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    sort: 'asc',
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Client Name',
    field: 'clientName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    resizable: false,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const frameworkComponents = {
  checkboxRenderer: CheckBoxRender,
};
